import React, { useState, useEffect } from 'react';
import '../../styles/Checkbox.css';

/**
 * Компонент настраиваемого чекбокса с кастомными размерами и стилями.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {string} props.label - Подпись рядом с чекбоксом.
 * @param {function} [props.onChange] - Колбэк, вызываемый при изменении состояния чекбокса. Получает новый `boolean` в аргументе.
 * @param {string} [props.height] - Высота чекбокса.
 * @param {string} [props.width] - Ширина чекбокса или всей обёртки (по умолчанию `"100%"`).
 * @param {boolean} [props.checked] - Управляемое состояние чекбокса (внешний контроль).
 * @param {string} [props.margin] - Отступы вокруг контейнера.
 * @param {string} [props.id='customCheckbox'] - Идентификатор для input/label.
 *
 * @returns {JSX.Element} Кастомный элемент чекбокса.
 */

const Checkbox = ({ label, onChange, height, width, checked, margin, id = 'customCheckbox' }) => {
  const [isChecked, setChecked] = useState(false);

  // Обновляем isChecked, если пропс checked изменился
  useEffect(() => {
    if (checked !== undefined) {
      setChecked(checked);
    }
  }, [checked]);

  const toggleCheckbox = () => {
    setChecked(!isChecked);
    if (onChange) {
      onChange(!isChecked);
    }
  };

  const containerStyle = isChecked ? 'checkbox-container checked' : 'checkbox-container';
  const checkboxStyle = isChecked ? 'checkbox-input checked' : 'checkbox-input';

  return (
    <div
      className={containerStyle}
      style={{
        width: width ? width : `100%`,
        height: height ? height : `var(--sadr-font-size-100)`,
        margin: margin,
      }}
    >
      <input type="checkbox" className={checkboxStyle} id={id} checked={isChecked} onChange={toggleCheckbox} />
      <label htmlFor={id} className="checkbox-label">
        {label}
      </label>
    </div>
  );
};

export default Checkbox;  
